import { axiosInstance } from '@/lib/axios'

export type RemoveTimesheetsRequestArgs = {
  id: string
  companyId: string
  driverIds: number[]
  months: number[]
  year: number
}

// Creates the background removal task (TaskType.Timesheet + RemoveTimesheets flag);
// progress is polled via getImportTaskStatus with the returned/request id.
export function requestRemoveTimesheets(props: RemoveTimesheetsRequestArgs) {
  const { companyId } = props
  return axiosInstance.post(`/api/${companyId}/timesheet/removeTimesheets`, props)
}
